window.Blimp = window.Blimp || {};

class ZoomPhotoView extends Backbone.View {
  get className() {
    return 'photo';
  }

  render(
    // Reason behind muted or not:
    // https://help.uberflip.com/hc/en-us/articles/360048856591-Why-are-my-autoplay-videos-muted-#:~:text=Answer,videos%20to%20autoplay%20with%20sound.
    muted = true
  ) {
    const top_controls = $('<div class="top controls"/>');
    top_controls.append(`<h2>${this.model.index()}/${this.model.report.photos.length} – ${this.model.report.get('references')[0]}</h2>`);
    top_controls.append('<a href="#" class="close"><i class="fa fa-times-circle fa-lg"></i></a>');
    this.$el.append(top_controls);

    const bottom_controls = $('<div class="bottom controls"/>');
    if (this.model.has('taken_at')) { // old reports are missing taken_at attributes in json cache
      bottom_controls.append(`<div class="meta">${this.model.taken_at().format('dddd, YYYY-MM-DD, HH:mm (UTC Z)')}</div>`);
    }
    if (Blimp.can_delete_photos) {
      bottom_controls.append('<a href="#" class="delete">Delete</a>');
    }
    bottom_controls.append(`<a href="${this.model.download_url()}" class="download">Download</a>`);
    this.$el.append(bottom_controls);

    if (this.model.is_video()) {
      this.$el.append(`
        <video class="video-player" width="${this.model.get('width')}" height="${this.model.get('height')}" autoplay ${muted ? 'muted' : ''} controls>
          <source src="${this.model.zoom_url()}" type="video/mp4">
        Your browser does not support the video tag.
        </video>
      `);
    } else {
      if (this.model.preloaded) {
        this.$el.append(`<img src="${this.model.zoom_url()}">`);
      } else {
        this.$el.append(`<img src="${this.model.thumb_url()}">`);
        const img = new Image();
        img.onload = () => {
          this.$el.find('img').replaceWith(img);
          this.model.preloaded = true;
        };
        img.src = this.model.zoom_url();
      }
    }

    return this;
  }
}

Blimp.ZoomPhotoView = ZoomPhotoView;